import { RowItemAttributes } from '@/types'
import { UpdateRowItemMutation } from './__generated__/update_mutation'
import { Mutation as UpdateMutation } from './update_mutation'
import { useForm } from '@/helpers/useForm'
import { EditRowItemQuery } from './__generated__/edit_query'
import { Query as EditQuery } from './edit_query'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'

type RowItem = EditRowItemQuery['rowItems']['nodes'][0]

interface Props {
  id: string
}

export const Form = ({ id }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    queryError,
    queryLoading,
    mutationLoading
  } = useForm<UpdateRowItemMutation, RowItemAttributes, EditRowItemQuery, RowItem>({
    id,
    initializer: ri => ({
      name: ri.name,
      priceCents: ri.priceCents || 0,
    }),
    query: EditQuery,
    queryKey: 'rowItems',
    mutation: UpdateMutation,
    resultKey: 'updateRowItem'
  })

  if (queryLoading) return <Loading />

  return (
    <>
      { queryError && <Error message={queryError} /> }
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        <div className="grid grid-cols-2 gap-6">
          { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
          { formBuilder.buildField({ name: 'Price', field: 'priceCents', type: 'currency' }) }
        </div>
        { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
      </div>
    </>
  )
}
